import React = require('react');
import { Button } from 'react-bootstrap';
import { CSSProperties } from 'react';

interface IAdmiralOfferCard {
  image: any,
  titleText?: any,
  contentText?: any,
  buttonText: string,
  redirectUrl?: string,
  contentStyle?: CSSProperties
  buttonStyle?: CSSProperties
  buttonClass?: string
}

export const AdmiralOfferCard = ({
                                   image,
                                   titleText,
                                   contentText,
                                   buttonText,
                                   redirectUrl,
                                   contentStyle,
                                   buttonStyle,
                                   buttonClass
                                 }: IAdmiralOfferCard) => {

  const redirectOnClick = () => {
    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    }
  }

  return (
    <div className={'offer-card offer-card-admiral'} style={{ background: `center/cover no-repeat url(${image})` }}>
      <div className={'content'}
           style={contentStyle ? contentStyle : null}> {/* extra div because of content-box sizing */}
        <div className={'title'}>{titleText}</div>
        <div className={'text'}>{contentText}</div>
        <Button className={!buttonClass ? 'admiral-secondary-btn' : buttonClass} onClick={redirectOnClick} style={buttonStyle}>{buttonText}</Button>
      </div>
    </div>
  );

}
